import { GridCellProps, GridColumnProps, GridFilterCellProps } from '@progress/kendo-react-grid'
import { useAppSelector } from 'store'

import { TickmillCompanyAllowedReferralsDtoKey } from '../../../api/Trading-Accounts/Types/TickmillCompanyAllowedReferralsDto'
import { multiSelectFilterCell } from '../../../components/Filter/FilterCell'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const CompaniesFilterCell: React.FC<GridFilterCellProps> = (props) => {
  const tickmillCompanies = useAppSelector((state) => state.identity.tickmillCompanies)

  return multiSelectFilterCell({
    items: tickmillCompanies.map((x) => ({ id: x.id, value: x.id, label: x.name })),
    options: {
      operator: '==',
    },
  })(props)
}

const referralsRestrictionsColumns: GridColumn[] = [
  {
    title: 'IB Entity',
    field: TickmillCompanyAllowedReferralsDtoKey.tickmillCompany,
    filterCell: CompaniesFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.tickmillCompany?.name) {
        return <td />
      }

      return <td>{props.dataItem.tickmillCompany.name}</td>
    },
    show: true,
  },
  {
    title: 'Allowed Entity',
    field: TickmillCompanyAllowedReferralsDtoKey.allowedTickmillCompany,
    filterCell: CompaniesFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.allowedCompany?.name) {
        return <td />
      }

      return <td>{props.dataItem.allowedCompany.name}</td>
    },
    show: true,
  },
]

export default referralsRestrictionsColumns
